/* istanbul ignore file */
import { FC, useRef } from 'react';
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from '@material-ui/core';
import { injectIntl, IntlShape } from 'react-intl';
import { get, isEmpty } from 'lodash';
import { translate } from 'containers/services/translate';
import messages from 'containers/TransactionManagerTimeLine/VictimInfo/messages';
import { COLORS } from 'constants/design';
import CustomAccordion from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/CustomAccordion';
import victimIcon from 'images/victim-icon.svg';
import { CLAIM } from 'containers/data-structure';
import { MANAGEMENT_MODES } from 'containers/RecapManagerPage/constants';
import { SagisConfig } from 'containers/AppContainer/typings';

export interface ScaleCasesProps {
  intl: IntlShape;
  listings: any;
  claim: any;
}

const ScaleCases: FC<ScaleCasesProps> = props => {
  const { claim } = props;
  const inputLabel = useRef<HTMLLabelElement>(null);
  const getCircumstances = () => {
    let circumstances = get(props.listings, 'circumstance', []).filter(
      (circumstance: SagisConfig) =>
        circumstance.ItemGroup === claim[CLAIM.SCALE_CASE_KEY],
    );
    return circumstances;
  };
  return (
    <CustomAccordion
      title={translate({ ...messages.scaleCasesTitle }, props)}
      textColor={COLORS.ACCORDION_TEXT_BLUE}
      bgColor={COLORS.ACCORDION_BG_BLUE}
      image={victimIcon}
    >
      <Grid container direction="row" spacing={3} alignItems="center">
        <Grid item xs>
          <FormControl fullWidth>
            <InputLabel ref={inputLabel} id="management-mode" className="label">
              {translate({ ...messages.managementMode }, props)}
            </InputLabel>
            <Select
              name="management-mode"
              value={String(get(claim, 'managementModeKey'))}
              onChange={() => {}}
            >
              {!isEmpty(get(props.listings, 'modeGestion', [])) &&
                get(props.listings, 'modeGestion', [])
                  .filter(
                    (mode: { ItemKey: string; ItemDescription: string }) =>
                      mode.ItemKey != '2',
                  )
                  .map((mode: { ItemKey: string; ItemDescription: string }) => (
                    <MenuItem value={mode.ItemKey} key={mode.ItemKey}>
                      {mode.ItemDescription}
                    </MenuItem>
                  ))}
            </Select>
          </FormControl>
        </Grid>

        {get(claim, [CLAIM.MANAGEMENT_MODE]) ===
          MANAGEMENT_MODES.COMMON_RIGHT ||
        get(claim, [CLAIM.MANAGEMENT_MODE]) === MANAGEMENT_MODES.FOREIGN ? (
          <Grid item xs={3}>
            <FormControl fullWidth>
              <InputLabel ref={inputLabel} id="scaleCase" className="label">
                {translate({ ...messages.scaleCase }, props)}
              </InputLabel>
              <Select
                name={CLAIM.SCALE_CASE_KEY}
                value={get(claim, [CLAIM.SCALE_CASE_KEY])}
                onChange={() => {}}
                disabled={true}
              >
                {!isEmpty(get(props.listings, 'casDeBareme', [])) &&
                  get(props.listings, 'casDeBareme', []).map(
                    (scaleCase: SagisConfig) => (
                      <MenuItem
                        value={scaleCase.ItemKey}
                        key={scaleCase.ItemKey}
                      >
                        {scaleCase.ItemDescription}
                      </MenuItem>
                    ),
                  )}
              </Select>
            </FormControl>
          </Grid>
        ) : (
          <Grid item xs={3}>
            <FormControl fullWidth>
              <InputLabel ref={inputLabel} id="scaleCase" className="label">
                {translate({ ...messages.scaleCase }, props)}
              </InputLabel>
              <Select
                name={CLAIM.SCALE_CASE_KEY}
                value={get(claim, [CLAIM.SCALE_CASE_KEY])}
                onChange={() => {}}
                disabled={true}
              >
                {!isEmpty(get(props.listings, 'casDeBareme', [])) &&
                  get(props.listings, 'casDeBareme', []).map(
                    (scaleCase: SagisConfig) => (
                      <MenuItem
                        value={scaleCase.ItemKey}
                        key={scaleCase.ItemKey}
                      >
                        {scaleCase.ItemDescription}
                      </MenuItem>
                    ),
                  )}
              </Select>
            </FormControl>
          </Grid>
        )}
        <Grid item xs={3}>
          {get(claim, [CLAIM.SCALE_CASE_KEY]) && (
            <FormControl fullWidth>
              <InputLabel
                ref={inputLabel}
                id="circumstanceCode"
                className="label"
              >
                {translate({ ...messages.circumstance }, props)}
              </InputLabel>
              <Select
                name={CLAIM.ACCIDENT_CIRCONSTANCE_KEY}
                value={get(claim, 'accidentCirconstanceKey')}
                onChange={() => {}}
                disabled={true}
              >
                {!isEmpty(getCircumstances()) &&
                  getCircumstances().map((circumstance: SagisConfig) => (
                    <MenuItem
                      value={circumstance.ItemKey}
                      key={circumstance.ItemKey}
                    >
                      {circumstance.ItemDescription}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          )}
        </Grid>
        {!isEmpty(get(claim, [CLAIM.ACCIDENT_CIRCONSTANCE])) &&
          get(claim, [CLAIM.ACCIDENT_CIRCONSTANCE_KEY]) && (
            <Grid item xs={3}>
              <TextField
                onChange={() => {}}
                name={CLAIM.ACCIDENT_CIRCONSTANCE}
                value={get(claim, [CLAIM.ACCIDENT_CIRCONSTANCE])}
                label={translate({ ...messages.circumstanceDetail }, props)}
                fullWidth
                multiline
                disabled={true}
              />
            </Grid>
          )}

        <Grid item xs={3}>
          {get(claim, [CLAIM.ACCIDENT_CIRCONSTANCE_KEY]) && (
            <FormControl fullWidth>
              <InputLabel
                ref={inputLabel}
                id="responsibility"
                className="label"
              >
                {translate({ ...messages.responsibility }, props)}
              </InputLabel>
              <Select
                name={CLAIM.RESPONSABILITY_KEY}
                value={get(claim, [CLAIM.RESPONSABILITY_KEY])}
                onChange={() => {}}
                disabled={true}
              >
                {!isEmpty(get(props.listings, 'responsability', [])) &&
                  get(props.listings, 'responsability', []).map(
                    (responsability: SagisConfig) => (
                      <MenuItem
                        value={responsability.ItemKey}
                        key={responsability.ItemKey}
                      >
                        {responsability.ItemDescription}
                      </MenuItem>
                    ),
                  )}
              </Select>
            </FormControl>
          )}
        </Grid>
        <Grid item xs={3}>
          {get(claim, [CLAIM.RESPONSABILITY_KEY]) && (
            <TextField
              id="standard-basic-desc"
              onChange={() => {}}
              name={CLAIM.ACCIDENT_DESCRIPTION}
              value={get(claim, [CLAIM.ACCIDENT_DESCRIPTION])}
              label={translate({ ...messages.description }, props)}
              fullWidth
              disabled={true}
              InputLabelProps={{ shrink: true }}
              multiline
            />
          )}
        </Grid>
      </Grid>
    </CustomAccordion>
  );
};

export default injectIntl(ScaleCases);
